import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { putIntegration } from './integrationPut';
import { QUERY_KEY } from './types';

const INTEGRATION_TYPE: IntegrationType = IntegrationType.GemApiKey;

function putGemIntegration(apiKey: string) {
  return putIntegration({
    integration_type: INTEGRATION_TYPE,
    gem: {
      api_key: apiKey,
    },
  });
}

export default function useGemIntegrationPut() {
  const queryClient = useQueryClient();
  return useMutation((data: { apiKey: string }) => putGemIntegration(data.apiKey), {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.invalidateQueries([QUERY_KEY, INTEGRATION_TYPE]);
    },
  });
}
